import React from 'react';
import { Icon } from '../../Icon';
import { IconColor } from '../../Icon/icon-color.enum';
import { IconMotif } from '../../Icon/icon-motif.enum';
import { IconVariant } from '../../Icon/icon-variant.enum';

// Displays an icon and a text/html with the correct paddings
export default function Fact({
  children,
  iconMotif,
  iconColor,
  iconVariant,
  altText,
  title,
  className = '',
}: {
  children: React.ReactNode;
  iconMotif: IconMotif;
  iconColor?: IconColor;
  iconVariant?: IconVariant;
  altText?: string | undefined;
  title?: string | undefined;
  className?: string;
}) {
  return (
    <div className={`d-flex align-items-center ${className}`}>
      <Icon motif={iconMotif} color={iconColor} variant={iconVariant} altText={altText} title={title} className="me-2" />
      {children}
    </div>
  );
}
